import { render, staticRenderFns } from "./launchgoods.vue?vue&type=template&id=c8b2c5ee&scoped=true"
import script from "./launchgoods.vue?vue&type=script&lang=js"
export * from "./launchgoods.vue?vue&type=script&lang=js"
import style0 from "./launchgoods.vue?vue&type=style&index=0&id=c8b2c5ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b2c5ee",
  null
  
)

export default component.exports